<template>
  <common-page
    ref="commonPage"
    page-type="hdPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :search-items="searchItems"
    :form-items="formItems"
    :d-table-config="dTableConfig"
  >
    <template #form-bottom>
      <d-table />
    </template>
  </common-page>
</template>
<script>
import DTable from "@/components/TkCommonPage/components/DTable.vue"

export default {
  components: { DTable },
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'base/dictionary/medicinedic/meddirectory',
      // Web路径
      webPath: 'base/dictionary/medicine_dic/med_directory',
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "name",
              name: "名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "name",
          name: "名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false,
                require: true,
                rules: [
                  { required: true, message: '请输入编码', trigger: 'blur' }
                ]
              }
            },
            {
              code: "name",
              name: "名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                require: true,
                rules: [
                  { required: true, message: '请输入名称', trigger: 'blur' }
                ]
              }
            }
          ]
        }
      ],
      // 子表配置
      dTableConfig: [
        {
          key: "medDictionary",
          name: "药品词典项",
          columns: [
            {
              code: "code",
              name: "编码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "name",
              name: "名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "dicDescribe",
              name: "词典描述",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "ind",
              name: "序号",
              type: "number",
              span: 6,
              config: {
                edit: false,
                disabled: true,
                precision: 2
              }
            },
            {
              code: "pinyinCode",
              name: "拼音码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
